import { render } from "./B2bFiltersFacturasRecibidas.vue?vue&type=template&id=2db49679&scoped=true&lang=pug"
import script from "./B2bFiltersFacturasRecibidas.vue?vue&type=script&lang=js"
export * from "./B2bFiltersFacturasRecibidas.vue?vue&type=script&lang=js"

import "./B2bFiltersFacturasRecibidas.vue?vue&type=style&index=0&id=2db49679&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2db49679"]])

export default __exports__